import { ReactNode } from "react";
import classNames from "classnames";

interface CardProps {
  children: ReactNode;
  header?: ReactNode;
  onClick?: () => void;
}

export const Card = ({ children, header, onClick }: CardProps) => (
  <div
    className={classNames(
      "flex overflow-hidden flex-col w-full h-full bg-white rounded-md shadow-md",
      {
        "cursor-pointer": !!onClick,
      }
    )}
    onClick={onClick}
  >
    {header && (
      <div className="p-1 md:px-2 text-md font-bold border-b border-mint-green text-emerald-green bg-mint-green-50">
        {header}
      </div>
    )}
    {children}
  </div>
);
